import React from 'react';
import {
  TEXT_INK, BRAND, TEXT_PRIMARY, BG_CARD, BORDER, DANGER, TEXT_TERTIARY,
} from '../styles';

interface Props {
  label: string;
  required?: boolean;
  value: string;
  onChange: (v: string) => void;
  error?: string;
  placeholder?: string;
  type?: string;
  helper?: string;
  maxLength?: number;
}

export default function FormField({
  label, required, value, onChange, error, placeholder, type, helper, maxLength,
}: Props) {
  return (
    <div>
      <label style={{ display: 'block', fontSize: 13, fontWeight: 600, color: TEXT_INK, marginBottom: 6 }}>
        {label}{required && <span style={{ color: BRAND, marginLeft: 4 }}>*</span>}
      </label>
      <input
        type={type || 'text'}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        maxLength={maxLength}
        style={{
          width: '100%', padding: '10px 12px',
          border: '0.5px solid ' + (error ? DANGER : BORDER),
          borderRadius: 8, fontSize: 14, fontFamily: 'inherit', outline: 'none',
          boxSizing: 'border-box', color: TEXT_PRIMARY, background: BG_CARD,
        }}
      />
      {error && <div style={{ fontSize: 12, color: DANGER, marginTop: 5 }}>{error}</div>}
      {helper && !error && <div style={{ fontSize: 11.5, color: TEXT_TERTIARY, marginTop: 5 }}>{helper}</div>}
    </div>
  );
}